module.exports = __webpack_public_path__ + "img/sbp.153574df.svg";